__turbopack_context__.v({
  "buttonContainer": "z7Duja_buttonContainer",
  "content": "z7Duja_content",
  "description": "z7Duja_description",
  "header": "z7Duja_header",
  "logo": "z7Duja_logo",
});
